import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { setSelectionBackRoute } from '../../redux/actions'

// CSS Imports
import './KitMenu.css'

// Helpers
import renderPrgImage from '../../source/programImg'
import renderImage from '../../source/importImg'
import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import { languageWords } from '../../utils/langaugeSupport'
import { EXPANSION_KITS } from '../../utils/expansionKits'

const BACKEND_URL = process.env.REACT_APP_API_BASE

const KitMenu = (props) => {
    const history = useHistory()
    const location = useLocation()

    const device = sessionStorage.getItem('allowedDevice') || 'Toki'

    const expansionKit = sessionStorage.getItem('expansionKit')

    // Remembers which subprogram the user picked on the previous screen
    const subprogramId = new URLSearchParams(location.search).get(
        'subprogramId'
    )

    // Title of the remembered subprogram, shown in the header for expansion kits
    const [subprogramTitle, setSubprogramTitle] = useState('')

    useEffect(() => {
        if (!subprogramId) return
        fetch(`${BACKEND_URL}/api/program/${device.toLowerCase()}`)
            .then((res) => res.json())
            .then((data) => {
                const sub = data?.subprograms?.find(
                    (s) => s.id === subprogramId
                )
                if (sub) setSubprogramTitle(sub.title)
            })
            .catch((err) => console.error('Failed to load program:', err))
    }, [subprogramId, device])

    // Toast state
    const [show_tost_text, setShow_tost_text] = useState({
        isShow: false,
        text: '',
    })

    const deviceVersion = sessionStorage.getItem('deviceVersion')?.split('.')?.slice(0, 2)?.join('.') || '1.0'

    const handleClick = (type) => {
        if (props.isConnecting) return

        switch (type) {
            case 'make':
                // Open the picked subprogram directly when one was remembered
                history.push(
                    subprogramId ? `/make/${subprogramId}` : '/make'
                )
                break
            case 'play':
                // PlayScreen reads the chosen subprogram from sessionStorage
                if (subprogramId) {
                    sessionStorage.setItem('playSubprogramId', subprogramId)
                    // Opened from the Kit Menu Play button: skip the final
                    // "Congratulations" step in PlayScreen.
                    sessionStorage.setItem('playHideFinalStep', 'true')
                    history.push('/PlayScreen')
                } else {
                    history.push('/play')
                }
                break
            case 'advanced':
                // Woof expansion kit is its own device built on top of Poki.
                // Once the user picks the Code engine, track it as 'woofKit'
                // so every device-keyed screen downstream can branch on it.
                if (expansionKit === 'woofExpansionKit3') {
                    sessionStorage.setItem('connectedDevice', 'woofKit')
                }
                props.setSelectionBackRoute('/kitMenu')
                history.push('/code')
                break
            default:
                break
        }
    }

    const goBack = () => {
        if (expansionKit) {
            // When the kit list was auto-skipped (device had a single kit),
            // return to the device list — that's the screen the user last saw.
            const autoSkipped =
                sessionStorage.getItem('expansionKitAutoSkipped') === 'true'
            if (autoSkipped) {
                sessionStorage.removeItem('expansionKitAutoSkipped')
                history.push(
                    `/expansionKitSelection?expansionKitDevice=${expansionKit}`
                )
                return
            }
            // Otherwise pass the picked device so the selection screen reopens
            // on the subprogram cards (where the user was), not the device list
            history.push(
                `/expansionKitSelection?expansionKitDevice=${expansionKit}&device=${device}`
            )
            return
        }
        history.push('/kitSelection')
    }

    const tokiModes = [
        {
            mode: 'make',
            label: 'Make',
            image: renderPrgImage('buildButton'),
            onClick: () => handleClick('make'),
            disabled: false,
        },
        {
            mode: 'play',
            label: 'Play',
            image: renderPrgImage('playButton'),
            onClick: () => handleClick('play'),
            disabled: false,
        },
        {
            mode: 'advanced',
            label: 'Code',
            image: renderPrgImage('appButton'),
            onClick: () => handleClick('advanced'),
            disabled: false,
        },
    ]

    return (
        <>
            <div className="Main_Select">
                {/* Header */}
                <div className="Select_Headers">
                    <MakeHeader
                        title={expansionKit ? `${subprogramTitle || EXPANSION_KITS[expansionKit]?.name || expansionKit}` : `${device} (v${deviceVersion})`}
                        titlePosition="left"
                        help_btnPosition="right"
                        isGoBack={true}
                        goBack={goBack}
                        showAccountSetting={true}
                        showHelp={true}
                        showBluetoothBtn={true}
                    />
                </div>

                {/* Body - Flex Container for 3 Items */}
                <div
                    id="tokiScrollContainer"
                    className="Toki_Body"
                    onWheel={(event) => {
                        document.getElementById(
                            'tokiScrollContainer'
                        ).scrollLeft += event.deltaY
                    }}
                >
                    {tokiModes.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className="Toki_Card"
                                onClick={item.onClick}
                                style={{
                                    backgroundImage: `url(${item.image})`,
                                    opacity: props.isConnecting ? 0.5 : 1,
                                    cursor: 'pointer',
                                }}
                            >
                                <div className="Toki_SubBody">
                                    <div className="Toki_Text">
                                        {languageWords[props.languageName]?.[
                                            item.label
                                        ] || item.label}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* Loader */}
            <div className="loading-overlay">
                {/* <ColorRing
                    visible={props.isConnecting || isLoadingData}
                    height="80"
                    width="80"
                    ariaLabel="color-ring-loading"
                    colors={[
                        '#e15b64',
                        '#f47e60',
                        '#f8b26a',
                        '#abbd81',
                        '#849b87',
                    ]}
                /> */}
            </div>

            {/* Toast */}
            {show_tost_text.isShow && (
                <p className="comingSoon_text">{show_tost_text.text}</p>
            )}
        </>
    )
}

const mapStateToProps = (state) => ({
    isConnecting: state.isConnecting,
    languageName: state.device.language,
})

const mapDispatchToProps = (dispatch) => ({
    setSelectionBackRoute: (data) => dispatch(setSelectionBackRoute(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(KitMenu)
